$(self).ready(() => {
	function getOGTags() {
		const OGTags = {};
		const metaTags = document.querySelectorAll('meta[property^="og:"]');

		metaTags.forEach((tag) => {
			const property = tag.getAttribute("property").replace("og:", "");
			const content = tag.getAttribute("content");
			if (property && content) {
				OGTags[property] = content;
			}
		});

		return OGTags;
	}

	function findAuthor() {
		if (document.body.classList.contains("category-the-backchannel"))
			return "Josh Marshall";

		return (
			document
				.querySelector(".ArticleFooter__AuthorInFooter .author-name")
				?.textContent.trim() || null
		);
	}

	function copyAsHTML(attrs) {
		const { nodes, title, url, author, date } = attrs;
		console.log(nodes);
		let innerHtml = "";
		// if nodes has len of 1 we've copied a subset of a paragraph
		// otherwise we've copied a selection of multiple nodes.
		if (nodes.length === 1) {
			innerHtml = `<!-- wp:paragraph --><p>${nodes[0].textContent}</p><!-- /wp:paragraph -->`;
		}
		// if you've only copied 1 paragraph, but it contains other tags (a, em, and so on), you'll still get an array of multiple nodes. need to concatenate those into a single
		else if (nodes[0].nodeName === "#text") {
			innerHtml = `<!-- wp:paragraph --><p>${nodes
				.map((node) => (node.outerHTML ? node.outerHTML : node.textContent))
				.join("")}</p><!-- /wp:paragraph -->`;
		} else {
			//this discards everything that isn't a heading or paragraph, on purpose!
			innerHtml = nodes
				.map((node) => {
					let nodeHtml = "";
					if (["H1", "H2", "H3", "H4", "H5", "H6"].includes(node.tagName)) {
						const level = node.tagName.charAt(1);
						nodeHtml = `<!-- wp:heading {"level":${level}} -->${node.outerHTML}<!-- /wp:heading -->`;
					} else if (node.tagName === "P") {
						nodeHtml = `<!-- wp:paragraph -->${node.outerHTML}<!-- /wp:paragraph -->`;
					} else if (node.tagName === "BLOCKQUOTE") {
						nodeHtml = `<!-- wp:quote -->${node.outerHTML}<!-- /wp:quote -->`;
						//if the node is a blockquote and is the first or last node, the outerHTML sometimes wont include the paragraph tag comments, lets add them
						nodeHtml = nodeHtml.replace(
							"</p></blockquote><!-- /wp:quote -->",
							"</p><!-- /wp:paragraph --></blockquote><!-- /wp:quote -->"
						);
						nodeHtml = nodeHtml.replace(
							'<blockquote class="wp-block-quote"><p>',
							'<blockquote class="wp-block-quote"><!-- wp:paragraph --><p>'
						);
					} else if (node.tagName === "UL" || node.tagName === "OL") {
						// Process list and wrap each list item with WordPress block comments
						const listItems = node.querySelectorAll("li");

						// Create a temporary element to manipulate the HTML
						const tempEl = document.createElement("div");
						tempEl.innerHTML = node.outerHTML;
						const listEl = tempEl.firstChild;

						// Replace each list item with the commented version
						let listItemsHtml = "";
						listItems.forEach((item) => {
							listItemsHtml += `<!-- wp:list-item -->${item.outerHTML}<!-- /wp:list-item -->  `;
						});

						// Set the inner HTML of the list to our processed items
						listEl.innerHTML = listItemsHtml;

						// Create the final HTML with surrounding list block comments
						nodeHtml = `<!-- wp:list -->${listEl.outerHTML}<!-- /wp:list -->`;
					} else if (node.tagName === "FIGURE") {
						let outerHtml = node.outerHTML;
						// Find and remove problematic attrs from img within the figure
						const imgEl = node.querySelector("img");
						if (imgEl && imgEl.hasAttribute("srcset")) {
							imgEl.removeAttribute("srcset");
							imgEl.removeAttribute("fetchpriority");
							imgEl.removeAttribute("width");
							imgEl.removeAttribute("height");
							imgEl.removeAttribute("decoding");
							imgEl.removeAttribute("sizes");
							imgEl.removeAttribute("style");
							// Update the outerHTML
							outerHtml = node.outerHTML;
						}

						// Try to find the image ID from data-image-id or wp-image-123 class pattern
						let id = null;

						// Look for wp-image-{id} class pattern
						const imgClasses = imgEl?.className || "";
						const wpImageMatch = imgClasses.match(/wp-image-(\d+)/);
						if (wpImageMatch && wpImageMatch[1]) {
							id = wpImageMatch[1];
						}

						// If we couldn't find an ID, dont include this figure in the output
						if (!id) {
							return "";
						}

						nodeHtml = `<!-- wp:image {"id":${id},"sizeSlug":"thumbnail","linkDestination":"none"} -->${outerHtml}<!-- /wp:image -->`;
					}
					return nodeHtml;
				})
				.join("");
		}

		const wrappedHtml = `
		<!-- wp:group {"className":"Clip", "layout":{"type":"constrained"}} -->
		<div class="wp-block-group Clip">

			${innerHtml}

			<!-- wp:paragraph {"className":"view-article is-style-sans-serif","style":{"elements":{"link":{"color":{"text":"#111111"}}},"color":{"text":"#111111"}}} -->
				<p class="has-text-color has-link-color view-article is-style-sans-serif" style="color:#111111"><a href="${url}"><strong>View Article <i class="fa-regular fa-arrow-right-long"></i></strong></a></p>
			<!-- /wp:paragraph -->

			<!-- wp:separator {"className":"is-style-default","style":{"color":{"background":"#c3c3c3"}}} -->
			<hr class="wp-block-separator has-text-color has-alpha-channel-opacity has-background is-style-default" style="background-color:#c3c3c3;color:#c3c3c3"/>
			<!-- /wp:separator -->
			
			<!-- wp:paragraph {"style":{"elements":{"link":{"color":{"text":"#999999"}}},"color":{"text":"#999999"},"typography":{"fontSize":"13px"}}} -->
				<p class="Clip__Footer has-text-color has-link-color " style="color:#999999;font-size: 13px">
					<em><strong>From: ${title}</strong></em>
					
				</p>
			<!-- /wp:paragraph -->

			<!-- wp:paragraph {"className":"is-style-sans-serif", "style":{"elements":{"link":{"color":{"text":"#999999"}}},"color":{"text":"#999999"},"typography":{"fontSize":"13px"}}} -->
				<p class="Clip__Footer has-text-color has-link-color is-style-sans-serif" style="color:#999999;font-size: 13px">
					${author ? `By ${author} | ` : ``}${date}
				</p>
			<!-- /wp:paragraph -->

		</div>
		<!-- /wp:group -->
		`;
		//create a temporary textarea to copy the HTML to clipboard
		// Copy the HTML to clipboard using the Clipboard API
		try {
			navigator.clipboard
				.writeText(wrappedHtml)
				.then(() => console.log("Copied to clipboard"))
				.catch((err) => console.error("Failed to copy: ", err));
		} catch (err) {
			console.error("Clipboard API not available: ", err);
		}
		window.tpm_latest_clip = null;
	}

	// make available globally
	window.tpm_copy_clip = copyAsHTML;

	function clearClipboard() {
		// Clear the clipboard
		navigator.clipboard
			.writeText("")
			.then(() => console.log("Clipboard cleared"))
			.catch((err) => console.error("Failed to clear clipboard: ", err));
	}

	function clearNotification() {
		if (window.tpm_latest_clip) {
			document.body.removeChild(window.tpm_latest_clip);
			window.tpm_latest_clip = null;
		}
	}

	function createControl(range, attrs) {
		function eventHandler() {
			window.tpm_copy_clip(attrs);

			notification.innerHTML =
				'<i class="fa-regular fa-circle-check"></i> Copied to clipboard';
			notification.removeEventListener("click", eventHandler);

			setTimeout(() => {
				notification.style.opacity = "0";
				setTimeout(() => document.body.removeChild(notification), 500);
			}, 1500);
		}

		clearNotification();

		// Create and show a notification div at the beginning of the selection
		const notification = document.createElement("div");
		notification.className = "ClipControl";
		notification.innerHTML =
			'<i class="fa-regular fa-copy"></i> Clip this selection';

		// Position the notification near the selection
		const rect = range.getBoundingClientRect();
		notification.style.top = `${window.scrollY + rect.top - 40}px`;

		// Get more accurate left position by using the range's offset and client rects
		const rangeCopy = range.cloneRange();
		rangeCopy.collapse(true); // Collapse to start
		const startRects = rangeCopy.getClientRects();
		const startLeft = startRects.length > 0 ? startRects[0].left : rect.left;
		notification.style.left = `${window.scrollX + startLeft}px`;

		window.tpm_latest_clip = notification;

		//copy html & remove the notification
		notification.addEventListener("click", eventHandler);

		document.body.appendChild(notification);
	}

	document.addEventListener("mouseup", function (e) {
		if (
			window.location.hostname === "talkingpointsmemo.com" &&
			!window.tpm_profile.staff_id
		)
			return;

		// Return if the selection is not somewhere within .Article or .NewsletterArticle element
		const isInArticle =
			e.target.closest(".Article__Content") ||
			e.target.closest(".NewsletterArticle__Content");
		if (!isInArticle) {
			return;
		}

		if (!e.target.closest(".ClipControl")) {
			clearNotification();
		}

		const selected = window.getSelection();
		if (selected) {
			// Check if selection is empty or only whitespace
			if (!selected.toString().trim()) return;

			// Check if selection is inside a Clip element
			if (e.target.closest(".Clip")) {
				clearClipboard();
				return;
			}

			const range = selected.getRangeAt(0);
			const docFragment = range.cloneContents();

			const attrs = {};
			attrs.nodes = Array.from(docFragment.childNodes);

			const ogTags = getOGTags();
			attrs.title = ogTags.title || document.title;
			attrs.url = ogTags.url || window.location.href;

			attrs.author = findAuthor();

			attrs.date = document
				.querySelector(".AuthorAndDate__Date")
				?.textContent.trim();

			createControl(range, attrs);
		}
	});
});
